module.exports = __webpack_public_path__ + "static/media/facebook-disabled.eed76d26.svg";